/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { CodePerShift } from '../../utils/codePerShift';
import { Turn } from '../../interfaces';

interface Props {
  style?: any;
  options: Array<any>;
  data: Array<any>;
  onChange?: any;
  id: string | number;
  period: number;
  periodSelected: boolean;
  label?: string;
  typeOperation?: string;
  setPeriod?: any;
  CodePerShift?: Array<Turn>
}

const SelectInput: React.FC<Props> = ({
  data,
  onChange,
  id,
  options,
  periodSelected,
  period,
  style,
  label,
  typeOperation,
}) => {
  const [value, setValue] = useState('');
  const handleChange = (event: any) => {
    if (typeOperation === 'LIMITE') {
      if (period === 1) {
        // @ts-ignore
        CodePerShift[0].limiteAgendamentosTurnoPorUsuario = event.target.value;
      }
      if (period === 2) {
        // @ts-ignore
        CodePerShift[1].limiteAgendamentosTurnoPorUsuario = event.target.value;
      }
      if (period === 3) {
        // @ts-ignore
        CodePerShift[2].limiteAgendamentosTurnoPorUsuario = event.target.value;
      }
      setValue(event.target.value);
      onChange(CodePerShift);
      return;
    }
    onChange(data?.map((item) => {
      if (item.idDiaDaSemana === id) {
        item?.hours?.map((it: any) => {
          if (it.idTurno === period) {
            it.quantidadePosicoes = event.target.value;
            return it;
          }
          return it;
        });
        return item;
      }
      return item;
    }));
  };

  const handleValue = () => {
    let values: string | null = null;

    if (typeOperation === 'LIMITE') {
      if (period === 1) {
        // @ts-ignore
        values = CodePerShift[0].limiteAgendamentosTurnoPorUsuario;
      }
      if (period === 2) {
        // @ts-ignore
        values = CodePerShift[1].limiteAgendamentosTurnoPorUsuario;
      }
      if (period === 3) {
        // @ts-ignore
        values = CodePerShift[2].limiteAgendamentosTurnoPorUsuario;
      }

      return values;
    }

    data?.map((item) => {
      if (item.idDiaDaSemana === id) {
        item?.hours?.map((it: any) => {
          if (it.idTurno === period) {
            values = it.quantidadePosicoes;
            return it;
          }
          return it;
        });
        return item;
      }
      return item;
    });
    return values;
  };

  return (
    <TextField
      id="outlined-select-currency"
      select
      placeholder="Posição"
      disabled={!periodSelected}
      size="small"
      label={label === undefined ? 'Posições' : label}
      style={style === undefined ? { marginTop: 8, width: '100%' } : style}
      value={handleValue() || value}
      onChange={handleChange}
      variant="outlined"
    >
      {options?.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
        >
          {option.label || option.nome}
        </MenuItem>
      ))}
    </TextField>
  );
};
export default SelectInput;
